import React from "react";
import CustomModel from "./customModel";

function Popup(props) {
  const { open, content, buttonContent, onClose } = props;
  return (
    <CustomModel
      className="bg-white rounded-3xl"
      open={open}
      showCloseIcon={false}
      closeOnOverlayClick={false}
    >
      <div className="flex flex-col items-center py-6 px-4">
        <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mb-4">
          <svg
            className="w-8 h-8 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">Success</h3>
        <p className="text-sm text-gray-500 text-center mb-6">{content}</p>
        <button
          onClick={onClose}
          className="w-full py-3 bg-primary hover:bg-primary-light rounded-xl text-white font-semibold text-sm"
        >
          {buttonContent}
        </button>
      </div>
    </CustomModel>
  );
}

export default Popup;
